import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ProviderManagementService } from '@core/service';
import { ProviderAccountHistoryDTO } from '@core/model';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-provider-history-table',
    templateUrl: './provider-history-table.component.html',
    styleUrls: ['./provider-history-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProviderHistoryTableComponent implements OnChanges {
  @Input() providerAccountId: string = null;
  @Input() authNumber: string = null;
  @Input() tenantId: string = null;

  history: ProviderAccountHistoryDTO[];
  isLoading = false;

  constructor(
    private providerManagementService: ProviderManagementService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('providerAccountId')) {
      this.isLoading = true;
      this.providerManagementService
        .getProviderPgpHistoryList(this.tenantId, this.providerAccountId, this.authNumber)
        .pipe(
          finalize(() => {
            this.isLoading = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe({
          next: history => (this.history = history)
        });
    }
  }
}
